import type { NextPage } from 'next';

import { Page as Component } from '~/containers/specifics/vendors/home/Page';

import { NskHead } from '~/components/common/head/NskHead';

export const PATH = '/vendors';

const Home: NextPage = () => (
  <>
    <NskHead title="ダッシュボード" />
    <Component />
  </>
);

export default Home;
